import ReactGA from 'react-ga';
import { withRouter } from 'react-router-dom';
import { clone } from 'ramda';

var initialized = false;

const init = (trackingId, options) => {
  ReactGA.initialize(trackingId, options || {});
  initialized = true;
};

const registerPageview = ({ pathname }) => {
  ReactGA.pageview(pathname);
};

const GoogleAnalyticsProvider = (props) => {
  // intialize only once; do not track dev
  if (!initialized && window.location.host !== 'localhost:3000') {
    init(props.trackingId, clone(props.options));
    props.history.listen(registerPageview);
    registerPageview(props.location);
  }

  return null;
};


export default withRouter(GoogleAnalyticsProvider);



// WEBPACK FOOTER //
// ./src/common/utils/ga/index.js